import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";


gsap.registerPlugin(ScrollTrigger);

const heroSection = () => {
    const heroSectionTl = gsap.timeline({
        paused: true
    });

    const text = new SplitText(".hero-section h1, .hero-section h4, .filter-section p,  .filter-section ul li a", { type: "chars" });

    gsap.set(".hero-section h1 > div,.hero-section h4 > div, .filter-section p > div,  .filter-section ul li a > div", {
        opacity: 0,
        y: 15
    });


    heroSectionTl.set('.hero-section', {
        className: "+= hero-section active",
    }, 0.15).to(text.chars, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.015,
    }, 1)

    ScrollTrigger.create({
        scroller:'[data-scroll-container]',
        trigger: '.hero-section',
        start: 'top bottom-=200',
        end: 'bottom top',
        animation: heroSectionTl,
        toggleActions: 'play none none none',
    });
};

export default heroSection;